import React, { memo } from 'react'
import { ReactComponent as BackIconSVG } from './BackIconSVG.svg'
import { isLocalLink } from '../../../helpers/url'
import { Link } from 'gatsby'

import styles from './BackButton.module.scss'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string
  href?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  download?: boolean
  openNewTab?: boolean
  disabled?: boolean
  buttonId?: string
}

export default memo(function BackButton({
  type,
  href,
  label = '',
  onClick,
  disabled,
  buttonId,
  openNewTab,
}: ButtonProps) {
  const newTabProps = openNewTab && { target: '_blank', rel: 'noreferrer' }

  return href ? (
    isLocalLink(href) ? (
      <Link className={styles.root} id={buttonId} to={href} onClick={onClick} aria-label={label} {...newTabProps}>
        <BackIconSVG />
        <span>Back</span>
      </Link>
    ) : (
      <a className={styles.root} id={buttonId} href={href} onClick={onClick} aria-label={label} {...newTabProps}>
        <BackIconSVG />
        <span>Back</span>
      </a>
    )
  ) : (
    <button className={styles.root} id={buttonId} type={type} onClick={onClick} aria-label={label} disabled={disabled}>
      <BackIconSVG />
      <span>Back</span>
    </button>
  )
})
